import { useShopifyCartContext } from '../onboarding/OnboardingFlowContainer/ShopifyCartProvider';

export const useCartLineItemForPet = petId => {
  const shopifyCartApi = useShopifyCartContext();

  const pet = shopifyCartApi.cart?.pets?.find(p => p.id === petId);

  const lineItemForPet = pet?.starter_box || null;

  const addonsForPet = pet?.extras || [];

  return {
    ...shopifyCartApi,
    lineItemForPet,
    addonsForPet,
  };
};
